@if (topSalesStore.errorCode) {
  <div class="w-full flex justify-content-center">
    @switch (topSalesStore.errorCode) {
      @case (ErrorCodes.loading) {
        <div
          class="inline-block align-self-center h-16 w-16 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status">
        </div>
      }
      @default {
        <analytics-error-message [analysisErrorState]="topSalesStore.errorCode"></analytics-error-message>
      }
    }
  </div>
} @else {
  <div class="w-full grid grid-cols-1 sm:grid-cols-2 sm:top-n-sales-grid-template">
    <div [class.hidden]="hideMenu" class="sm:block mr-4 justify-end">
      <div class="sticky  sm:top-1/4 xl:top-0 mt-0 pt-0">
        <div>
          <div class="flex align-baseline justify-start border-b border-gray-200 pb-3 pt-3">
            <div class="flex w-6">
              <svg class="bi bi-arrow-down-up" height="24" viewBox="0 0 16 16"
                   width="24" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  fill-rule="evenodd"/>
              </svg>
            </div>
            <label class="text-gray-900 text-lg place-self-center ml-3">Sortieren nach</label>
          </div>
          <fieldset class="mt-4 flex flex-col space-y-4" ngDefaultControl>
            <div (click)="topSalesStore.setSortedByTotalSalesRevenue(true)" class="flex cursor-pointer">
              <div class="flex items-center w-6">
                <div [class.border-blue-600]="topSalesStore.sortedByTotalSalesRevenue"
                     class="h-4 w-4 rounded-full border-[1px] border-gray-500 cursor-pointer mx-auto p-0.5">
                  @if (topSalesStore.sortedByTotalSalesRevenue) {
                    <div class="h-full w-full rounded-full bg-blue-600"></div>
                  }
                </div>
              </div>
              <label class="ml-3 block text-sm leading-6 text-gray-600 cursor-pointer">Umsatz</label>
            </div>
            <div (click)="topSalesStore.setSortedByTotalSalesRevenue(false)" class="flex cursor-pointer">
              <div class="flex items-center w-6">
                <div class="flex items-center w-6">
                  <div [class.border-blue-600]="!topSalesStore.sortedByTotalSalesRevenue"
                       class="h-4 w-4 rounded-full border-[1px] border-gray-500 cursor-pointer mx-auto p-0.5">
                    @if (!topSalesStore.sortedByTotalSalesRevenue) {
                      <div class="h-full w-full rounded-full bg-blue-600"></div>
                    }
                  </div>
                </div>
              </div>
              <label class="ml-3 block text-sm leading-6 text-gray-600 cursor-pointer">Verkäufen</label>
            </div>
          </fieldset>
        </div>
        <div class="flex mt-3 border-b border-gray-200 pb-3 pt-3">
        <span class="flex w-6">
          <svg class="place-self-center mx-auto fill-none" height="32" stroke="currentColor"
               stroke-width="1.5"
               viewBox="0 0 24 24" width="32"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        </span>
          <span class="place-self-center ml-3 text-lg text-gray-900">
          Standorte
        </span>
        </div>

        <div class="border-b border-gray-200 py-6">
          <!-- Filter section, show/hide based on section state. -->
          <div class="pt-6" id="filter-section-0">
            <div class="space-y-4">
              @for (locationKey of topSalesStore.topSalesData | keyvalue; track locationKey.key) {
                <div class="flex items-center">
                  <div class="flex w-6">
                    <input (change)="topSalesStore.toggleLocationIsActive(locationKey.key);"
                           [id]="locationKey.key"
                           [ngModel]="topSalesStore.isActive(locationKey.key)"
                           class="h-4 w-4 rounded border-gray-300 text-theme-primary-700 focus:ring-theme-primary-900 select-none cursor-pointer mx-auto"
                           name="color[]" type="checkbox"
                           value="white">
                  </div>
                  <label [for]="locationKey.key"
                         class="ml-3 text-sm text-gray-600 select-none cursor-pointer">{{ topSalesStore.mapLocationIdToName(locationKey.key) }}</label>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [class.hidden]="!hideMenu" class="sm:block  w-full">
      <ul class=" divide-y mt-0 divide-gray-800" role="list">
        @for (composition of topSalesStore.mapActiveLocationsToTopSalesSortedView(); track composition.id; let i = $index) {
          <li class="flex justify-between gap-x-6 py-2">
            <div class="flex min-w-0 gap-x-4 w-full">
              <div class="min-w-0 flex-auto">
                <!--
                  #534: in "Kombinationen einzeln" mode the article stays the headline and the swap combination
                  reads as sub-lines underneath, exactly like the composition table and the event-details
                  article list.

                  The connector gets its OWN fixed-width monospace column (`.modification-connector`,
                  styles.scss) instead of being part of the sub-line text. That is the whole point: `├` and `└`
                  have different glyph widths in the proportional body font, so a joined string put the `└`
                  line visibly out of column against the `├` lines above it.
                -->
                @let modificationLines = topSalesStore.mapCompositionIdToModificationLines(composition);
                <div class="flex  justify-between ">
                  <p class="text-sm font-semibold leading-6 text-black">
                    {{ topSalesStore.mapCompositionIdToArticleName(composition) }}</p>
                  <p class="text-sm font-semibold leading-6 text-black">#{{ i + 1 }}</p>
                </div>
                @if (modificationLines.length > 0) {
                  <div class="modification-lines text-xs leading-5 text-gray-500">
                    @for (line of modificationLines; track $index) {
                      <div class="modification-line">
                        <span class="modification-connector">{{ line.connector }}</span>{{ line.text }}
                      </div>
                    }
                  </div>
                }
                <div class="flex justify-between">
                  <p
                    class="mt-1 truncate text-xs leading-5 text-gray-500">{{ composition.totalSalesRevenue | currency: "EUR" }}</p>
                  <p class="mt-1 truncate text-xs leading-5 text-gray-500 ">Anzahl an
                    Verkäufen: {{ composition.topSalesQuantity }}</p>
                </div>
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
}







